import { action } from 'satcheljs';
import { QuickComposePivotType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { OwaDate } from 'owa-datetime';

export const setQuickComposeActivePivot = action(
    'setQuickComposeActivePivot',
    (pivot: QuickComposePivotType) => ({ pivot })
);

export const updateQuickComposePivotContent = action(
    'updateQuickComposePivotContent',
    (pivot: QuickComposePivotType, previousPivot: QuickComposePivotType) => ({
        pivot,
        previousPivot,
    })
);

export const updateCachedEventData = action(
    'updateCachedEventData',
    (data: Partial<CalendarEvent>) => ({ data })
);

export const setQuickComposeEventBodyViewState = action(
    'setQuickComposeEventBodyViewState',
    (body: EditorViewState) => ({ body })
);

export const updateOofStartEndDates = action(
    'updateOofStartEndDates',
    (startDate: OwaDate, endDate: OwaDate) => ({ startDate, endDate })
);
